"use client";
// import { useEffect } from "react";
import { motion } from "framer-motion";

export const TextGenerateEffect = ({ words, className }) => {
  return (
    <div className={className}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        {words.split(" ").map((word, idx) => (
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay: idx * 0.2,
            }}
            key={idx}
          >
            {word}{" "}
          </motion.span>
        ))}
      </motion.div>
    </div>
  );
};
